import { forwardRef } from "react";
import { TableVirtuoso } from "react-virtuoso";
import { NavLink } from "react-router-dom";

const TableHead = forwardRef((props, ref) => (
  <thead ref={ref} className="virtuoso-table-thead" {...props} />
));

const TableFoot = forwardRef((props, ref) => (
  <tfoot ref={ref} className="border-b" {...props} />
));

const BasicTable = ({ headers, data = [], footerContent, other_params={}, }) => {
  return (
    <div style={{ overflowX: "auto", width: "100%" }}>
      <TableVirtuoso
        style={{
          height: data?.length ? other_params?.height?other_params.height:"calc(100vh - 177px)" : "100%",
          minWidth: "100%",
        }}
        data={data}
        components={{
          Table: (props) => (
            <table
              {...props}
              className={`table table-striped table-bordered table-hover table-responsive  ${other_params.class || ''}`}
              style={{ minWidth: "100%", whiteSpace: "nowrap" }}
            />
          ),
          TableHead,
          TableRow: (props) => <tr {...props} className="border-b" />,
          TableFoot,
        }}
        fixedHeaderContent={() => (
          <tr>
            {headers.map((header, index) => (
              <th
                className={header.className}
                key={index}
                style={{ background: "#fff" }}
              >
                {header.label}
              </th>
            ))}
          </tr>
        )}
        fixedFooterContent={() => (
          footerContent ? footerContent : <tr>
            {data?.length > 0 && (
              <td
                align="left"
                colSpan={headers.length}
                style={{ background: "#fff" }}
              >
                Total Records: {data?.length || 0}
              </td>
            )}
          </tr>
        )}
        itemContent={(index, value) =>
          headers.map((item, idx) => (
            <td
              className={item.className}
              key={idx}
              style={item.width ? { width: item.width } : {}}
            >
              {item?.addLink &&
              item.addLink.toLowerCase() === "yes" &&
              item.urlLink ? (
                <NavLink to={`/${item.urlLink}${item.renderLink(value)}`}>
                  {item.render(value)}
                </NavLink>
              ) : (
                item.render(value)
              )}
            </td>
          ))
        }
      />
      {!data?.length && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            placeContent: "center",
            flexWrap: "wrap",
            height: "100px",
            border: "1px solid #f3f3f3",
            background: "var(--bs-table-striped-bg)",
          }}
        >
          No record found..
        </div>
      )}
    </div>
  );
};

export default BasicTable;
